import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApisService } from 'app/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ask-ai',
  templateUrl: './ask-ai.component.html',
  styleUrls: ['./ask-ai.component.scss']
})
export class AskAiComponent implements OnInit {
  aiForm : FormGroup

  constructor(
    private apiService : ApisService,    
    private fb : FormBuilder        
  ) { }

  ngOnInit(): void {
    this.setForm()
  }
  // Sending data to API 
  setForm(){ 
    this.aiForm = this.fb.group({
      question: ['', Validators.required]
    })
  }

  // Ask AI API 
  askAI(data:any){ 
    this.apiService.askAI(data).subscribe({
      next:(response :any ) => { 
        console.log("response" , response);
      }, 
      error(err) {
          console.log("error in sending data", err);
      },
    });
  }

  onSubmit() { 
    if (this.aiForm.valid) {
      console.log('Form Data:', this.aiForm.value);
      console.log('Form Submitted Successfully');
      this.askAI(this.aiForm.value);
    } else {
      console.log('Please fill all required fields');
    }
  }
}
